import { render } from "./ChildView.vue?vue&type=template&id=7e82a9cc"
import script from "./ChildView.vue?vue&type=script&lang=js"
export * from "./ChildView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__